import { Controller, useFormContext } from "react-hook-form";

import { TextField } from "ui/text-field";
import { Select } from "ui/select";
import { TextArea } from "ui/text-area";

import { GRADE_OPTIONS } from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/sms-simulator-personas-form.constants";

const SmsSimulatorPersonasForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2.5">
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <TextField
              label="Name"
              placeholder="Add persona name here..."
              required
              errMessage={errors?.name?.message as string}
              {...field}
            />
          )}
        />
        <Controller
          name="grade"
          control={control}
          render={({ field: { onChange, value, ...field } }) => (
            <Select
              label="Grade"
              selectName="grade"
              placeholder="Select grade"
              options={GRADE_OPTIONS}
              required
              errMessage={errors?.grade?.message as string}
              ariaLabel="Select a grade"
              value={GRADE_OPTIONS.find((option) => option.value === value) || null}
              onChange={(selectedOption: any) => onChange(selectedOption?.value)}
              {...field}
            />
          )}
        />
      </div>
      <Controller
        name="profileType"
        control={control}
        render={({ field }) => (
          <TextField
            label="Profile Type"
            placeholder="Add persona profile type here..."
            required
            errMessage={errors?.profileType?.message as string}
            {...field}
          />
        )}
      />
      <Controller
        name="interests"
        control={control}
        render={({ field }) => (
          <TextArea
            label="Interests"
            placeholder="Add persona interests here..."
            required
            errMessage={errors?.interests?.message as string}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.stopPropagation();
              }
            }}
            {...field}
          />
        )}
      />
    </div>
  );
};

export default SmsSimulatorPersonasForm;
